import React, { useCallback, useMemo, useState } from 'react'
import Table from '../../../../components/Table'
import { useForm } from 'react-hook-form';
import { useEffect } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { loaderAction } from '../../../../redux/actions/Index';
import axios from 'axios';
import { environment } from '../../../../env';
import EmptyTable from '../../../../components/errorComponents/EmptyTable';
import { Form, Input } from 'reactstrap';
import PathName from '../../../../components/PathName/PathName';
import { debounce } from 'lodash';
import { toast } from 'react-toastify';

const TenantHistory = () => {
    const [tenantdetails, setTenantDetails] = useState([]);
    const [filter, setFilter] = useState([])
    const userProject = useSelector((state) => state?.ModalReducer?.userproject);

    const dispatch = useDispatch();
    const {
        register,
        handleSubmit,
        watch,
        control,
        formState: { errors },
    } = useForm();
    const dateDiff = (data, id) => {
        const curDate = moment().format('YYYY-MM-DD');
        const newDate = moment(data).format('YYYY-MM-DD');
        var today = moment(newDate)
        var rentEndDate = moment(curDate)
        let dateDif = today.diff(rentEndDate, 'days')
        return dateDif
    }
    const columns = [
        {
            name: 'Status',
            selector: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
                <label className={`icon-bg-red icon-color-red rounded-pill status-box rounded fs-4`}>{row.terminate == true ? "Terminated" : dateDiff(row.rent_end_date, row.id) < 0 ? "Ended" : "Ended"}</label>
            </div>,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Old day',
            selector: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
                <label className={`${(row.terminate == true && dateDiff(row.terminate_date) > 0) ? 'icon-bg-green icon-color-green' :
                    'icon-bg-red icon-color-red '} rounded-pill status-box rounded fs-4`}>{row.terminate == true ? (dateDiff(row.terminate_date, row.id) < 0 ? -(dateDiff(row.terminate_date, row.id)) : dateDiff(row.terminate_date, row.id)) + ' ' + "Days" :
                        (dateDiff(row.rent_end_date, row.id) < 0 ? -(dateDiff(row.rent_end_date, row.id)) : dateDiff(row.rent_end_date, row.id)) + ' ' + "Days"}</label>
            </div>,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Tenant Name',
            selector: row => row.proposal.name_of_company,
            wrap: true,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Building',
            selector: row => row.building.building_no,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Email',
            selector: row => row.proposal.company_email,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Contact No',
            selector: row => row.proposal.contact_number,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Area',
            selector: row => (row.proposal.required_area) + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Aggreement Start Date',
            selector: row => moment(row.aggrement_start_date).format('DD/MM/YYYY'),
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Rent End Date',
            selector: row => moment(row.rent_end_date).format('DD/MM/YYYY'),
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        }
    ]
    const period = watch("period")
    const getTenant = async () => {
        dispatch(loaderAction(true))
        try {
            await axios.get(`${environment.baseUrl}add-gala-tenant/`).then((customerdata) => {
                let array = []
                let dataa = customerdata.data.filter((data) => data.project.id == userProject)
                dataa.map((data) => {
                    let date1 = moment(data.terminate_date);
                    let date2 = moment().format('YYYY-MM-DD');
                    let days = date1.diff(date2, 'days')
                    if (days <= 0 || data.terminate == true || data.status == 'Vacated'  || data.status == 'vacated' ) {
                        if(dateDiff(data.terminate_date) <= 0){
                            array.push(data)
                        }else{
                            array.push(data)
                        }
                    }
                })
                setTenantDetails(array);
                dispatch(loaderAction(false))
            })
        }
        catch (err) {
            dispatch(loaderAction(false))
            console.log(err);
        }

    }
    const onSubmit = (data) => {
        debounce(data);
    };
    const debounce = useCallback(
        _.debounce((_searchVal) => {
            Search(_searchVal);
        }, 500),
        []
    );
    const Search = (reason) => {
        let arr = []
        tenantdetails?.filter((item) => {
            if (item?.proposal?.name_of_company?.toUpperCase().includes(reason.toUpperCase())) {
                return arr.push(item)
            }
        })
        if (arr.length == 0) {
            setFilter([])
            toast.error('Tenant History not found !', {
                position: toast.POSITION.TOP_CENTER
            });
        } else {
            return setFilter(arr)
        }
    }

    useMemo(() => {
        setTenantDetails(tenantdetails);
    }, [tenantdetails])

    useEffect(() => {
        getTenant()
    }, [userProject])

    return (
        <>
            <PathName />
            <div className="tenant-history-main">
                <Form onSubmit={handleSubmit(Search)}>
                    <div className='my-3 pb-1'>
                        <div className='d-flex align-items-center bg-white px-4 border-radius-10'>
                            <Input
                                className='p-4 border-0 shadow-none   w-100 fs-3 title-font-500 fs-2 '
                                type='text'
                                autoComplete='off'
                                placeholder='Search Tenant Name Here...'
                                {...register('search', {
                                    onChange: (e) => onSubmit(e.target.value)
                                })}
                            />
                        </div>
                        <br />
                    </div>
                </Form>
                <div className="bg-white p-5 rounded-5 mb-5 shadow-sm">
                    <div className="d-flex justify-content-between align-items-center mb-5 ">
                        <h1 className='title-font-bold '>Tenant History </h1>
                        {/* <span className='fs-2 text-base-color base-font-600'>{period != 0 && `You selected ${period == 15 ? "( 15 day )" : period == 30 ? "( 1 Months )" : period == 45 ? "( 45 days )" : period == 60 && "( 2 Months )"}`}</span> */}
                    </div>
                    {tenantdetails?.length != 0 ? <Table columns={columns} data={filter.length != 0 ? filter : tenantdetails} /> : <EmptyTable />}
                </div>
            </div>
        </>
    )
}

export default TenantHistory